"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPhysicalCardItemPage = getPhysicalCardItemPage;
exports.getPhysicalCardPage = getPhysicalCardPage;
exports.updatePhysicalCardImg = updatePhysicalCardImg;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var requestUrl = '/xyPhysicalCard';
function getPhysicalCardPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/page',
    method: 'get',
    params: query
  });
}
function getPhysicalCardItemPage(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/itemPage',
    method: 'get',
    params: query
  });
}
function updatePhysicalCardImg(data) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/updateImg',
    method: 'put',
    data: data
  });
}